export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "es": {
        "labels": {
          "go_back_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Volver a la lista de procesos"])},
          "producers": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Productores"])},
          "total_exported": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Total exportado (Kg)"])},
          "total_exported_explanation": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Es la cantidad total exportada en kilogramos"])},
          "productivity": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kg/Ha"])},
          "productivity_explanation": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["kilogramos por hectárea"])},
          "productivity_monthly": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kg/Ha/mes"])},
          "productivity_monthly_explanation": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Es la cantidad total (Kg) por hectárea en relación a los meses cosechados"])},
          "productivity_weekly": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kg/Ha/sem"])},
          "productivity_weekly_explanation": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Es la cantidad total (Kg) por hectárea en relación a las semanas cosechadas"])},
          "download_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Descargar reporte"])},
          "performance_labels": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Indicadores de rendimiento"])}
        }
      },
      "en": {
        "labels": {
          "go_back_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Go back to process list"])},
          "producers": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Producers"])},
          "total_exported": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Total exported (Kg)"])},
          "productivity": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kg/Ha"])},
          "productivity_monthly": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kg/Ha/month"])},
          "productivity_weekly": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kg/Ha/week"])}
        }
      }
    }
  })
}